import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { SEVERITY_BADGE_LARGE_CLASS } from '@/lib/severity';
import type { Severity } from '@/types/alerts';

interface SeverityBadgeLargeProps {
  severity: Severity;
  className?: string;
}

/**
 * Oversized, saturated severity badge — used exclusively in the Fraud
 * Hub Critical Alerts Board so the urgency carries from across the
 * room. Smaller surfaces (Fraud Center table rows etc.) keep the
 * muted variant from `SEVERITY_BADGE_CLASS`.
 */
export function SeverityBadgeLarge({
  severity,
  className,
}: SeverityBadgeLargeProps): JSX.Element {
  return (
    <Badge
      variant="outline"
      className={cn(
        'px-3 py-1 text-base font-bold uppercase tracking-wide',
        SEVERITY_BADGE_LARGE_CLASS[severity],
        className,
      )}
    >
      {severity}
    </Badge>
  );
}

export default SeverityBadgeLarge;
